import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './scss/main.scss';
// ToDo: времянка для демо - удалить
import './screens/cardServices/style.scss';
import './shared/components/menu/components/dropdownMenu/style.scss';
import './screens/profile/common/applications/style.scss';
import './shared/components/visuallyImpaired/button/style.scss';
import './screens/news/components/allNews/newsItem/style.scss';
import 'swiper/swiper.scss';
import App from './app';
import * as serviceWorker from './serviceWorker';
import {configureBugsnag} from './bugsnag.configure';
import Bugsnag from '@bugsnag/js';

configureBugsnag();
const ErrorBoundary =
  Bugsnag?.getPlugin('react')?.createErrorBoundary(React) || (((props: any) => <>{props.children}</>) as any);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
